import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountAlias'
})
export class AccountNumberAliasPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (!value) 
    { return ''; } 
    if(value.length != 12) 
    { return value; } 
    // Remove trailing zeros 
    const saccoId = value.substring(0,5); 
    const accountNum = value.substring(6,12); 
    const accountId = parseInt(accountNum); 
    // Remove leading '9002' and append '13' 
    const shortenedValue = parseInt((saccoId + accountId.toString())); 
    return shortenedValue.toString(36); 
  }
}


